import HeroSection from "../components/sections/HeroSection";
import AboutSection from "../components/sections/AboutSection";
import MenuHighlights from "../components/sections/MenuHighlights";
import GallerySection from "../components/sections/GallerySection";
import TestimonialsSection from "../components/sections/TestimonialsSection";
import ContactSection from "../components/sections/ContactSection";

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <MenuHighlights />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
}
